import { Box, Modal, Pagination, Paper, Stack, TextField, Typography, modalClasses } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import "./OutletApproval.css"
import { ChannelkartNetworkGet } from '../../services/networkService'
import { GenericTable } from '../../components/genericTable/GenericTable'
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid'
import { Loader } from '../../components/loader/Loader'
import RenderSvg from '../../components/renderSvg/RenderSvg'
import GenericViewAndEditModal from '../../components/ouletModal/GenericViewAndEditModal'
import { Tab } from '../../components/ouletModal/OutletModalTypes'
import { popupType } from '../../types/types'
import { GenericPopUp } from '../../components/popup/genericPopUp'
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider'

export default function OutletApproval() {
    const { translate } = usePortalTranslation();
    const CUR_COMPONENT_COMMON="commonPortal";
    const CUR_COMPONENT="Outlet Approval";
    const [rows, setRows] = useState([]);
    const [pages, setPages] = useState(0);
    const [loader, setLoader] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchedValue, setSearchedvalue] = useState("");
    const [timerId, setTimerId] = useState<NodeJS.Timeout | null>(null);
    const [openModal, toggleModal] = useState(false);
    const [modelData, setModelData] = useState<any>();
    const [buttonText, setButtonText] = useState<string>("");
    const [mdmModalConfig, setMDMModalConfig] = useState<Tab[]>([]);
    const [genericModalState, setGenericModalState] = useState(false);
    const [genericModalMessage, setGenericModalSMessage] = useState("");
    const [genericModaltype, setGenericModalType] = useState<popupType>("Error");

    const setGenericMetaData = (
        message: string,
        type: popupType,
        state: boolean
    ) => {
        setGenericModalState(state);
        setGenericModalSMessage(message);
        setGenericModalType(type);
    };

    const outletApprovalModalData: Tab[] = [
        {
            tabName: "Overview",
            fields: [
                { disabled: "true", id: "outletcode", label: "distributor_outlet_code", type: "textfield" },
                { disabled: "true", id: "outlet_name", label: "outlet_name", type: "textfield" },
                { disabled: "true", id: "outlet_category", label: "outlet_category", type: "textfield" },
                { disabled: "true", id: "outlet_class", label: "outlet_class", type: "textfield" },
                { disabled: "true", id: "outlet_type", label: "outlet_type", type: "textfield" }
            ]
        },
        {
            tabName: "Information",
            fields: [
                { disabled: "true", id: "mobile", label: "mobile", type: "textfield" },
                { disabled: "true", id: "channel", label: "channel", type: "textfield" },
                { disabled: "true", id: "subchannel", label: "subchannel", type: "textfield" }
            ]
        },
        {
            tabName: "Others",
            fields: [
                { disabled: "true", id: "beat_PJP", label: "beat_PJP", type: "textfield" },
                { disabled: "true", id: "channel", label: "channel_type", type: "textfield" }
            ]
        },
    ];

    const outletRejectModalData = outletApprovalModalData.map(tab => ({
        ...tab,
        fields: [
            ...tab.fields,
            { disabled: "false", id: "remarks", label: "remarks", type: "description" }
        ]
    }));

    const outletApprovalData: any = {
        actions: [
            "approve", "reject"
        ],
        columns: [
            { headerName: "Outlet Code", mappedValue: "outletcode" },
            { headerName: "Outlet Name", mappedValue: "outlet_name" },
            { headerName: "Secondary Code", mappedValue: "secondaryOutletCode" },
            { headerName: "Requested By", mappedValue: "modified_by" },
            { headerName: "Requested Date", mappedValue: "creation_time" },
            { headerName: "Channel", mappedValue: "channel" },
            { headerName: "Status", mappedValue: "active_status" },
        ]
    }

    const debouncingTheSearch = useCallback(
        (value: string) => {
            if (timerId) {
                clearTimeout(timerId);
            }
            const newTimerId = setTimeout(() => {
                setLoader(true);
                setCurrentPage(1);
                getTableRows(1, value);
            }, 400);
            setTimerId(newTimerId);
        },
        [searchedValue, timerId]
    );

    const getAllEntityMetaData = async (page: number, searchedValue?: string,) => {
        let url: string = "";
        if (searchedValue) {
            url = `/v1/query/get_Distributer_approvedOutlets?size=30&page=${page}&dataToSearch=${searchedValue}&source=portal&callType=scheduled`
        }
        else {
            const designations = JSON.parse(localStorage.getItem("authContext") ?? "{}")?.user?.designation;
            const role = designations?.length ? designations[0] : "";
            url = `/v1/query/approvalQuery?size=30&page=${page}&entity=OutletDetails&role=${role}&tableName=ck_outlet_details&source=portal&callType=scheduled`;
        }
        const response = await ChannelkartNetworkGet(url);
        return response;
    }
    const getTableRows = async (
        currentPage: number = 1,
        searchedValue?: string,
    ) => {
        try {
            const response = await getAllEntityMetaData(
                currentPage - 1,
                searchedValue,
            );
            setRows(response?.data?.features);
            setPages(response?.data?.totalPage);
            setLoader(false);
        } catch (error) {
            setRows([]);
            setLoader(false);
        }

    };

    const columns: GridColDef[] = outletApprovalData.columns.length
        ? outletApprovalData.columns.map((columnsMetaData: any) => {
            return {
                disableColumnMenu: true,
                field: columnsMetaData.mappedValue,
                headerName: translate(TranslationEnum.outlet_approval,columnsMetaData.headerName).toUpperCase(),
                sortable: false,
                minWidth: 100,
                flex: 1,
                headerAlign: "center",
                align: "center",
                valueGetter: (params: GridRenderCellParams) => {
                    const field = params.field;
                    if (field === 'creation_time') {
                        return params?.row[field]?.substring(0, 10)
                    }
                    return params.row[field];
                },
            };
        })
        : [];

    if (outletApprovalData.actions.includes("approve")) {
        columns.push({
            field: "Edit",
            headerName: "",
            sortable: false,
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            align: "center",
            disableColumnMenu: true,
            renderCell: (params: GridRenderCellParams) => {
                return (
                    <div
                        className="edit-button"
                        onClick={() => {
                            setMDMModalConfig(outletApprovalModalData)
                            setButtonText("Approve")
                            setModelData(params.row);
                            toggleModal(true);
                        }}
                    >
                        <RenderSvg name="Reset-password" />
                        <span className="edit-button-text">{translate(TranslationEnum.common_portal,"Approve")}</span>
                    </div>
                );
            },
        });
    }

    if (outletApprovalData.actions.includes("reject")) {
        columns.push({
            field: "Reject",
            headerName: "",
            sortable: false,
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            align: "center",
            disableColumnMenu: true,
            renderCell: (params: GridRenderCellParams) => {
                return (
                    <div
                        className="edit-button"
                        onClick={() => {
                            setMDMModalConfig(outletRejectModalData)
                            setButtonText("Reject")
                            setModelData(params.row);
                            toggleModal(true);
                        }}
                    >
                        <RenderSvg name="Reset-password" />
                        <span className="edit-button-text">{translate(TranslationEnum.common_portal,"Reject")}</span>
                    </div>
                );
            },
        });
    }

    useEffect(() => {
        const fetchData = async () => {
            await getTableRows(currentPage);
        };
        fetchData();
    }, []);
    return (
        <Paper className="manageBannerPaperContainer">
            <Box className="manageBannerBoxContainer">
                <div className="manageBannerBar">
                    <div className="manageBannerBoxHeading">
                        <Typography
                            className="bannerReportHeading"
                            variant="h6"
                            pl={2}
                        >
                             {translate(TranslationEnum.outlet_approval,"Admin Approval")}
                        </Typography>
                    </div>
                    <div className="search-field">
                        <input
                            type="text"
                            placeholder={translate(TranslationEnum.common_portal,"Search")}
                            name="search"
                            autoFocus
                            className="search-input-field"
                            value={searchedValue}
                            onChange={(e) => {
                                setSearchedvalue(e.target.value);
                                debouncingTheSearch(e.target.value);
                            }}
                        />
                    </div>
                </div>
                <GenericPopUp
                    type={genericModaltype}
                    message={genericModalMessage}
                    openGenericModal={genericModalState}
                    setOpenGenericModal={() => {
                        genericModaltype === 'Success' && getTableRows(1);
                        setGenericModalState(false);
                    }}
                />
                {loader ? (
                    <Loader />
                ) : (
                    <div className="table-style">
                        <GenericTable
                            searchedProps={[]}
                            table={{
                                rows,
                                columns,
                                isOfflineSearchEnable: false,
                                hideFooter: true,
                            }}
                        />
                        <div className="pagination">
                            <Pagination
                                count={pages}
                                variant="outlined"
                                shape="rounded"
                                color={"primary"}
                                onChange={async (event, value) => {
                                    setCurrentPage(value);
                                    setLoader(true);
                                    await getTableRows(value);
                                }}
                                page={currentPage}
                            />
                        </div>
                    </div>
                )}
                <Modal
                    open={openModal}
                    onClose={() => {
                        toggleModal(false);
                    }}
                >
                    <> <GenericViewAndEditModal
                        modelData={modelData}
                        close={() => toggleModal(false)}
                        mdmModalConfig={mdmModalConfig}
                        buttonText={buttonText}
                        setGenericMetaData={setGenericMetaData}
                    /></>
                </Modal>
            </Box>
        </Paper>
    )
}
